import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/data/schedule.json';

const ScheduleAnima = ({ className = '' }) => {
  return (
    <div className={`schedule-anima ${className}`}>
      <Lottie animationData={animationData} loop={true} autoplay={true} />
    </div>
  );
};

export default ScheduleAnima;
